import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class';
import * as fieldComponents from '../../components/fields/multiple-choice-v1/multiple-choice-v1-index';

@Injectable({
    providedIn: 'root'
})
export class MultipleChoiceV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'multiple-choice-v1';
    menuTitle: string = "Multiple Choice";
    deprecated: boolean = false;


    /**
      * 
      * @param field the object data of the field
      * @returns MultipleChoiceV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.SingleTagSelectorV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsMultipleChoiceV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsMultipleChoiceV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        const f =  new fields.SettingsMultipleChoiceV1Field(field.type, field.position);
        return f.deserialize(field);
    }

    getSettingsComponentType(): Type<fieldComponents.SettingsMultipleChoiceV1FieldComponent> {
        return fieldComponents.SettingsMultipleChoiceV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillMultipleChoiceV1FieldComponent> {
        return fieldComponents.FillMultipleChoiceV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewMultipleChoiceV1FieldComponent> {
        return fieldComponents.ViewMultipleChoiceV1FieldComponent;
    }
}

